import { render, staticRenderFns } from "./KpiResultTab.vue?vue&type=template&id=45ec8e13&scoped=true"
import script from "./KpiResultTab.vue?vue&type=script&lang=js"
export * from "./KpiResultTab.vue?vue&type=script&lang=js"
import style0 from "./KpiResultTab.vue?vue&type=style&index=0&id=45ec8e13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec8e13",
  null
  
)

export default component.exports